<!-- nav -->
<!-- <nav class="navbar navbar-expand-lg navbar-light bg-theme">
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div style="width: 80%">
    <img
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      src="assets/img/banner.jpg"
      style="width: auto; height: 60px; margin-left: 35px"
    />
  </div>
  <div
    class="collapse navbar-collapse justify-content-end"
    id="navbarSupportedContent"
  >
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a
          class="nav-link"
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Home <span class="sr-only">(current)</span></a
        >
      </li>
      <li class="nav-item">
        <a
          *ngIf="!isLoggedin"
          routerLink="/account/login/"
          routerLinkActive="active"
          routerLinkActive="active"
          class="nav-link"
          >Login</a
        >
      </li>
      <li *ngIf="isLoggedin" class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="navbarDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          My Profile
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a
            *ngFor="let pt of patient.info.others.data"
            (click)="gotoPatient(pt)"
            class="dropdown-item"
          >
            <small>{{ pt.name_first }} {{ pt.name_last }}</small>
            <p>{{ pt.pid || pt.temporary_id }}</p>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" *ngIf="isLoggedin" (click)="logout()"
            >Logout</a
          >
        </div>
      </li>
    </ul>
  </div>
</nav> -->

<!-- App Header (Visible on all screens) -->
<div class="app-header" *ngIf="!isAdminRoute()">
  <img src="assets/img/banner.jpg" class="logo" />

  <!-- Navigation Menu -->
  <div class="menu">
    <a
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="fas fa-home"></i>
      <span class="label">Home</span>
    </a>
    <a
      *ngIf="orders_module"
      routerLink="/browse-items"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      
    >
      <i class="fas fa-shopping-cart"></i>
      <span class="label">Orders</span>
    </a>
    <a
      *ngIf="!isLoggedin"
      routerLink="/account/login/"
      routerLinkActive="active"
    >
      <i class="fas fa-sign-in-alt"></i>
      <span class="label">Login</span>
    </a>
    <a *ngIf="isLoggedin" (click)="gotoPatient(patient.info.others.data[0])">
      <i class="fas fa-user"></i>
      <span class="label">Profile</span>
    </a>

    <a *ngIf="isLoggedin" (click)="logout()">
      <i class="fas fa-sign-out-alt"></i>
      <span class="label">Logout</span>
    </a>
  </div>
</div>

<!-- main app container -->
<div class="app-container">
  <alert></alert>
  <router-outlet></router-outlet>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="large"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white"></p>
</ngx-spinner>

<div class="modal" id="sesModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title text-center">Session Idle Notification</h4>
        <button type="button" #myDiv class="close" data-dismiss="modal">
          &times;
        </button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <p class="text-center">
          Hi, You are idle for {{ idle_sec }} seconds, You will be automatically
          logout after {{ sess_timeout }} seconds
          <!-- <button type="submit" class="login-btn btn-block mt-4">Stay</button> -->
        </p>
      </div>
    </div>
  </div>
</div>
